/**
 * UranIA PA — `/overview` (redirect a `/`).
 *
 * Fusione A.4.1 (Riordino della mappa delle rotte §4): `/` ha assorbito
 * il contenuto che viveva qui (`features/overview/OverviewPage.tsx`,
 * ora montata su `routes/index.tsx`). Questa rotta resta solo perché
 * "ogni URL della mappa originale risponde: o la pagina, o una 301"
 * (criterio d'accettazione A.1 #2) — i link già circolati non si
 * rompono.
 */

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as PubblicoRoute } from './_pubblico.tsx';

export const Route = createRoute({
  getParentRoute: () => PubblicoRoute,
  path: '/overview',
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true });
  },
});
